module.exports = __webpack_public_path__ + "img/tutorial06.e64662a4.svg";